import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawer: false,

    menuItems: [
      {
        text: 'Startseite',
        link: '/',
      },
      {
        text: 'Über Uns',
        link: '/ueber_uns/unser_haus',
        dropdown:[
          {text: 'Unser Haus', link: '/ueber_uns/unser_haus'},
          {text: 'Die Geschichte', link: '/ueber_uns/die_geschichte'},
          {text: 'Unser Team', link: '/ueber_uns/Unser_Team'},
          {text: 'Unser Pflegekonzept', link: '/ueber_uns/unser_pflegekonzept'},
        ]
      },
      {
        text: 'Angebote',
        link: '/angebote/kurzzeitpflege',
        dropdown: [
          {text: 'Kurzzeitpflege', link: '/angebote/kurzzeitpflege'},
          {text: 'Langzeitpflege', link: '/angebote/langzeitpflege'},
          {text: 'Gemeinsames Mittagessen', link: '/angebote/gemeinsames_mittagessen'},
          {text: 'Zivildienstplätze', link: '/angebote/zivildienstplaetze'},
          {text: 'Praktikumsplätze', link: '/angebote/praktikumsplaetze'},
          {text: 'Heimentgelte', link: '/angebote/heimentgelte'},
        ]
      },

      {
        text: 'Kontakt & Anfahrt',
        link: '/kontakt_anfahrt',
      }
    ]
  },

  mutations: {
    setDrawer: (state, payload) => (state.drawer = payload),
    toggleDrawer: state => (state.drawer = !state.drawer),
  },
  actions: {
  },
})
